import React from 'react';
import Toggle from 'react-toggle'
import { Button } from 'react-bootstrap';
import { TrashFill } from 'react-bootstrap-icons';
import { useCompulsion } from './use-compulsion';
import useCourseDrop from './use-course-drop';

export const EnrolleeItem = ({
    courseId,
    enrollee,
}) => {
    const compulsion = useCompulsion({ courseId, user: enrollee });
    const { drop } = useCourseDrop({ courseId });

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: '10px',
                borderBottom: '1px solid rgba(0,0,0,0.1)'
            }}
        >
            <div style={{
                flex: 1,
                whiteSpace:'nowrap',
                overflow: 'hidden', whiteSpace:'nowrap'
            }}>
                 {enrollee.name} ({enrollee.gradeNumber})
                </div>
            <Toggle
                checked={Boolean(enrollee.isRequired)}
                onChange={(e) => compulsion.toggleCompulsion(e.target.checked)}
                value='yes'
            />
            <div>
                <Button size='sm' variant="outline-danger" onClick={() => drop(enrollee.id)}>
                    <TrashFill />
                </Button>
            </div>
        </div>
    );
};